export default class SoundList{
    public static BIG_WIN:string = 'big_win';
    public static MEGA_WIN:string = 'mega_win';
    public static SUPER_WIN:string = 'super_win';
    public static GRAND_WIN:string = 'grand_win';



    public static UI_BUTTON_CLICK:string  = 'button_click';
    public static UI_BUTTON_SPIN_START:string  = 'button_spin_start';
    public static UI_BUTTON_SPIN_STOP:string  = 'button_spin_stop';
    public static UI_REEL_SPIN:string  = 'reel_spin';
    public static UI_REEL_STOP:string  = 'reel_stop';

    public static UI_POPUP_HIDE:string = 'popup_hide';
    public static UI_POPUP_SHOW:string = 'show_popup';

    public static TRANSITION:string = 'transition';

    public static FREESPIN_AWARD:string = 'freespin_award';
    public static FREESPIN_WIN:string = 'freespin_win';

    public static UI_ERROR_APPEARANCE:string = 'error_appearance';

    public static COUNTER_LOOP:string = 'counter_loop';
    public static COUNTER_END:string = 'counter_end';

    public static TOTAL_WIN_APPEARANCE:string = 'total_win_appearance';
}
